module.exports = __webpack_public_path__ + "static/media/dashbord-icon.88a9b403.svg";